// User/API-scoped last successful readings survive page reloads. Logout already
// clears localStorage. Cache failure must never block the live request.
import { readingKey } from './monitoringData';

export function mergeCurrentRows(current, previous = []) {
    const bySensor = new Map(previous.map(row => [row.SensorCode, row]));
    return current.map(row => {
        const prior = bySensor.get(row.SensorCode);
        return prior && readingKey(prior.RefDate) > readingKey(row.RefDate) ? prior : row;
    });
}
function cacheKey() {
    const user = JSON.parse(localStorage.getItem('Auth') || '{}');
    return `monitoring:readings:v1:${JSON.stringify([import.meta.env.VITE_BASEURL, user.username || user.name || '', user.role || ''])}`;
}

export function readCurrentCache() {
    try {
        const cache = JSON.parse(localStorage.getItem(cacheKey()) || '{}');
        return Object.fromEntries(Object.entries(cache).filter(([, rows]) => Array.isArray(rows)
            && rows.length <= 500 && rows.every(row => row && typeof row.SensorCode === 'string' && typeof row.RefDate === 'string')));
    } catch { return {}; }
}

export function saveCurrentCache(key, current) {
    try {
        const cache = readCurrentCache();
        cache[key] = mergeCurrentRows(current, cache[key]);
        localStorage.setItem(cacheKey(), JSON.stringify(cache));
    } catch { /* A full/disabled browser store does not change request success. */ }
}
